module.exports = __webpack_public_path__ + "img/orange-dual-terror.dfe64eb0.jpg";